import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined, SearchOutlined, PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import Notiflix from "notiflix";

import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  Col,
  Descriptions,
  Divider,
  Button,
  Modal,
  Space,
  Spin,
  Tooltip,
  Table
} from "antd";

//OTHER IMPORTS
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

import MainLayout from '../../../../components/layouts/MainLayout';
import TopContent from '../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../group.config";
import CustomButton from '../../../../components/custom/CustomButton';
import styles from '../../../../assets/styles/styles';


const { Text, Title } = Typography

const ManageMembers = (props) => {

  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [membersList, setMembersList] = useState([]);
  const [payloadData, setPayloadData] = useState([]);
  const [activationDate, setActivationDate] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [isCustomerSelected, setIsCustomerSelected] = useState(false);
  const [officeId, setOfficeId] = useState("");

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {

    const params = {
      associations: "clientMembers",
      template: true
    }
    const url = `${apiConfig.Groups}/${state.id}`;

    let body = {
      session,
      params
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        const tempArray = [];

        objList?.clientMembers?.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            clientId: element?.id ? element?.id : "-",
            name: element?.displayName ? element?.displayName : "-",
          });
        });

        setMembersList(tempArray);
        setOfficeId(objList.officeId)
        setIsLoading(false);
      }
    });
  }

  const handleCustomerDelete = (key) => {
    let action = "Remove ";
    let label = BOM.SubstringFormat(key.name, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const params = {
          command: "disassociateClients",
        }

        let formValues = { clientMembers: null }
        formValues.clientMembers = [key.id]

        const url = `${apiConfig.Groups}/${state.id}`;

        const body = {
          ...formValues,
          method: "POST",
          session,
          params
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            setIsLoading(false);
          } else {
            const newData = membersList.filter((item) => item.id !== key.id);
            setMembersList(newData);
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.removeMemberMsg);

            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };


  const columns = [
    {
      title: labelConfig.clientId,
      dataIndex: "clientId",
    },
    {
      title: labelConfig.name,
      dataIndex: "name",
    },

    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        membersList.length >= 1 ? (
          <Tooltip title={`Remove Member`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleCustomerDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];


  function onCancel() {
    navigate("/detail-group", { state: state });
  }

  const onSubmit = (formValues) => {

    let tempCustomerArray = [];
    payloadData.forEach((element, index) => {
      tempCustomerArray.push(element.id);
    });

    formValues.clientMembers = tempCustomerArray

    const params = {
      command: "associateClients",
    }

    const url = `${apiConfig.Groups}/${state.id}`;

    const body = {
      ...formValues,
      method: "POST",
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);

      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.manageCustomerMsg);
        navigate("/detail-group", { state: state });

        //STOP LOAD
        setIsLoading(false);
      }
    });

  };

  return (

    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.associateNewMembers}
        pageItems={staticConfig.associateNewMembersBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                >
                  Back
                </Text>
              </Button>

            </Row>
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.groupInfo}
                </Title>
              </Divider>

              <MemberSearchModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                setMembersList={setMembersList}
                membersList={membersList}
                session={session}
                officeId={officeId}
                isCustomerSelected={isCustomerSelected}
                setIsCustomerSelected={setIsCustomerSelected}
                setPayloadData={setPayloadData}
                payloadData={payloadData}
              />
            </Row>


            {membersList?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {membersList.length > 1
                      ? labelConfig.selectedMembers
                      : labelConfig.selectedMember}
                  </Title>
                </Divider>
                <Table
                  columns={columns}
                  dataSource={membersList}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )}

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>

        </Card>
      </Spin>

    </MainLayout>

  )
}
export default ManageMembers

const MemberSearchModal = (props) => {
  const {
    session,
    setMembersList,
    membersList,
    isModalOpen,
    setIsModalOpen,
    officeId,
    isCustomerSelected,
    setIsCustomerSelected,
    setPayloadData,
    payloadData
  } = props;

  const [useForm] = Form.useForm();
  const [customerData, setCustomerData] = useState([]);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [currentCustomerDetails, setCurrentCustomerDetails] = useState({});
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }
    setSearchParam(searchKey);
  }

  const onSearch = (officeId) => {

    setIsCustomerSelected(false);

    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }

    const params = {
      officeId: officeId ? officeId : null,
      orderBy: "displayName",
      orphansOnly: true,
      sortOrder: "ASC",
    };

    if (isNaN(searchParam)) {
      params.displayName = searchParam.trim()
    } else if (!isNaN(searchParam) && searchParam.toString().length > 8){
      params.mobileNo = searchParam
    } else {
      params.id = searchParam
    }

    const url = `${apiConfig.Clients}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    // return
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);

      } else {
        const objList = res.pageItems;
        let tempCustomerData = [];
        let tempCustomerDetails = [];

        objList?.forEach((element) => {
          tempCustomerData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objList?.forEach((element) => {
          tempCustomerDetails.push({
            key: element.id,
            id: element.id,
            name: element.displayName,
            office: element.officeName,
            clientId: element.id,
          });
        });

        if (tempCustomerData === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        setCustomerData(tempCustomerData);
        setCustomerDetails(tempCustomerDetails);
        setShowDetailsForm(true);
        setIsLoading(false);
        useForm.resetFields();

      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCustomerSave = (formValues) => {

    const newCustomer = customerDetails?.find(
      (item) => item.id === formValues.customerId
    );

    let foundCharge = membersList.find(
      (item) => item.id === newCustomer?.id
    );
    if (foundCharge) {
      BOM.AlertMsg(cnt.WARNING, "No duplicate Charge allowed!");
      return;
    }
    setMembersList([...membersList, newCustomer]);
    setPayloadData([...payloadData, newCustomer])
    useForm.resetFields();
  };

  const onChangeCustomer = (customerParam) => {
    const currentCustomerDetails = customerDetails?.find(
      (item) => item.id === customerParam
    );
    setCurrentCustomerDetails(currentCustomerDetails);
    setIsCustomerSelected(true);
  };

  const items = [
    {
      key: "1",
      label: labelConfig.id,
      children: customerDetails ? currentCustomerDetails?.id : "-",
      span: 3,
    },
    {
      key: "2",
      label: labelConfig.name,
      children: customerDetails ? currentCustomerDetails?.name : "-",
      span: 3,
    },
    {
      key: "3",
      label: labelConfig.office,
      children: customerDetails ? currentCustomerDetails?.office : "-",
      span: 3,
    },
  ];

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        className="of-primaryBtnColor"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
      >
        {labelConfig.addMember}
      </Button>

      <Modal
        title="Search For a Member"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleCustomerSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">

          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Space.Compact>
                <div>
                  <Input
                    onChange={handleSearchInTable}
                    placeholder="Search by Customer Name, ID or Mobile Number"
                    style={{ width: 460 }}
                    allowClear
                  />
                </div>
                <Button
                  type="primary"
                  className="of-primaryBtnColor"
                  onClick={() => onSearch(officeId)}
                >
                  <SearchOutlined />
                </Button>
              </Space.Compact>
            </Col>
          </Row>
          {showDetailsForm && (
            <>
              <Row>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {labelConfig.selectCustomer}
                  </Title>
                </Divider>
                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.customerList}
                    name={"customerId"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.customer),
                      },
                    ]}
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.customer,
                        "select"
                      )}
                      options={customerData}
                      showSearch
                      onChange={onChangeCustomer}
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {isCustomerSelected && (
            <Descriptions
              bordered
              column={{
                xs: 1,
                sm: 2,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              style={{ marginTop: 10, marginBottom: 20 }}
              items={items}
            />
          )}

        </Spin>
      </Modal>
    </Row>
  );
};